
import React, { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import useTranslation from '../../../Hooks/UseTranslation'
import { useNotifications } from '../../../Hooks/UseNotifications'

import NotificationsDialog from '../../../Components/NotificationsDialog/NotificationsDialog'

const ToggleNotifications = () => {

  const { t } = useTranslation()
  const { permissionStatus, requestDesktopPermission } = useNotifications()

  const notifications = useSelector((state: any) => state.NotificationsReducer.result)

  const [ showNotifications, setShowNotifications ] = useState(false)

  const notRead = useMemo(() => {

    if (!notifications) {

      return 0
    }

    return notifications.filter((notification: any) => notification.status === 'not_read').length
  }, [notifications])

  const openNotifications = () => {
    setShowNotifications(true)

    if (permissionStatus === 'default') {
      requestDesktopPermission()
    }
  }

  return (
    <>
      <div
        className="right-dropdown svg-icon-menu cursor-pointer"
        onClick={openNotifications}
        role="button"
        aria-label={t('NOTIFICATIONS:Title')}
        title={t('NOTIFICATIONS:Title')}
      >

        <div className="svg-icon-container">

          {!notRead ? null : (
            <span
              className="badge badge-primary"
            >
              {notRead}
            </span>
          )}
          <i className="far fa-bell"></i>
        </div>
      </div>

      <NotificationsDialog
        show={showNotifications}
        title={t('NOTIFICATIONS:Title')}
        notifications={notifications}
        onHide={() => setShowNotifications(false)}
      />
    </>
  )
}

export default ToggleNotifications
